<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href="route_back">Список организаций</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить организацию</li>
        </ol>
    </nav>

    <div class="col-md-4 col-12">
        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="input_name_client_id">Клиент <span class="color-red">*</span></label>
                <v-select
                    id="input_name_client_id"
                    v-model="formData.client_id"
                    :items="clients"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="org-name">Название организации <span class="color-red">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    id="org-name"
                    v-model="formData.name"
                    placeholder="Введите название организации"
                >
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="org-inn">ИНН организации <span class="color-red">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    id="org-inn"
                    v-model="formData.inn"
                    placeholder="Введите ИНН организации"
                    maxlength="10"
                    @input="filterDigits('inn')"
                >
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-12">
                <label class="form-label" for="org-kpp">КПП организации <span class="color-red">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    id="org-kpp"
                    v-model="formData.kpp"
                    placeholder="Введите КПП организации"
                    maxlength="9"
                    @input="filterDigits('kpp')"
                >
            </div>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start">
        <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="createOrg" />
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <Alert />
</template>

<script>
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import Organization from "../../../../models/Organization";
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";

export default {
    name: "OrganizationCreateComponent",
    components: { Alert, ConfirmBtn },
    props: {
        route_back: String,
        route_client_search: String,
        route_create: String
    },
    data() {
        return {
            organization: new Organization({
                route_client_search: this.route_client_search,
                route_create: this.route_create
            }),
            clients: [],
            formData: {
                client_id: null,
                name: '',
                inn: '',
                kpp: ''
            },
        };
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),

        searchClients: async function () {
            let clients = await this.organization.clients();
            this.clients = clients.items;
        },

        selectItem(id) {
            this.searchClients();
            console.log(id);
        },

        filterDigits(field) {
            // Удаляем все символы, кроме цифр
            this.formData[field] = this.formData[field].replace(/\D/g, '');
        },

        async createOrg() {
            if (!this.formData.client_id) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберите клиента!' });
                this.toggleLoading();
                return;
            }

            if (this.formData.name.trim() === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название организации!' });
                this.toggleLoading();
                return;
            }

            if (this.formData.inn.length !== 10) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'ИНН организации должен содержать ровно 10 цифр!' });
                this.toggleLoading();
                return;
            }

            if (this.formData.kpp.length !== 9) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'КПП организации должен содержать ровно 9 цифр!' });
                this.toggleLoading();
                return;
            }

            let result = await this.organization.create(this.formData);
            if (result) {
                window.location.href = this.route_back;
            } else {
                console.log('error: create_organization');
            }
        },
    },
    mounted() {
        this.searchClients();
    }
};
</script>

<style scoped>

</style>
